import { render, staticRenderFns } from "./VPagination.vue?vue&type=template&id=62b6eb38&"
import script from "./VPagination.vue?vue&type=script&lang=js&"
export * from "./VPagination.vue?vue&type=script&lang=js&"
import style0 from "./VPagination.vue?vue&type=style&index=0&id=62b6eb38&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports